import { render, staticRenderFns } from "./insert_user_aff_program.vue?vue&type=template&id=7156ccc9"
import script from "./insert_user_aff_program.vue?vue&type=script&lang=js"
export * from "./insert_user_aff_program.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports